import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'CommunityDetail',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    communityId: String
  },
  data () {
    return {
      loading: true,
      
      // テーブルオプション
      tableColumns: [
        'locationNumber',
        'deviceSerial',
        'modelNumber',
        'modelName',
        'profile1',
        'status',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          locationNumber: 'ロケーションID',
          deviceSerial: '端末製造番号',
          modelNumber: '品番',
          modelName: '機種名',
          profile1: 'プロフィール１',
          status: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          locationNumber: '',
          deviceSerial: '',
          modelNumber: '',
          modelName: '',
          profile1: '',
          status: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'locationNumber',
          'deviceSerial',
          'modelNumber',
          'modelName',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('ロケーション'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 検索
      searchLocationId: null,
      searchDeviceSerial: null,
      searchNickName: null,
      searchAttribute: '',
      searchDeviceType: '',
      searchStatus: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetDetail()
  },
  computed: {
    ...mapState({
      categoryName: state => state.community.categoryName,
      // model
      values: state => state.communityDetail.values,
      locationModel: state => state.communityDetail.locationModel,
      deviceTypeModel: state => state.communityDetail.deviceTypeModel
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      getValue: 'communityDetail/getValue',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    attributeList () {
      if (this.values.attributeTypes &&
        this.values.attributeTypes.length) {

        const list = [];
        this.values.attributeTypes
          .forEach(type => {
            const typeName = type.attributeTypeName;
            type.attributeGroups
              .forEach(group => {
                list.push({
                  value: group.attributeGroupUuid,
                  label: typeName + ' : ' + group.attributeGroupName
                });
              });
            });
        console.log('@', list);
        return list;
      } else {
        return [];
      }
      // return this.values.attributeTypes && this.values.attributeTypes.length
      //   ? this.values.attributeTypes.map(item => {
      //     return {
      //       value: item.attributeTypeUuid,
      //       label: item.attributeTypeName
      //     }
      //   })
      //   : []
    },
    deviceTypeList () {
      return this.values.modelNumber && this.values.modelNumber.length
        ? this.values.modelNumber.map(item => {
          const deviceTypeInfo = this.deviceTypeModel.find(
            device => device.modelNumber === item
          );
          return {
            value: deviceTypeInfo ? deviceTypeInfo.deviceTypeUuid : item,
            label: item
          }
        })
        : []
      // //TODO 選択中のコミュニティで設定されているデバイスの一覧
      // return [
      //   {value: 'xxx01', label: 'label'}
      // ]
    },
    statusList () {
      return Constants.Admp.LocationStatus.sort(Utility.sortByKey('index', true))
    },

    // result
    showCommunityTantou() {
      return this.getValue('communityTantous') &&
        this.getValue('communityTantous').length > 0
    },

    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      loadModel: 'communityDetail/loadModel',
      resetDetail: 'communityDetail/reset',
      loadLocationList: 'communityDetail/loadLocationList'
    }),

    init () {
      this.loading = true

      // パラメータ
      let communityParams = {
        communityUuid: this.communityId
      }
      let locationParams = {
        communityUuid: this.communityId,
        filters: {}
      }
      let deviceTypeParams = {
        filters: {}
      }

      // データ読出し
      this.loadModel({
        targetId: this.communityId,
        communityParams: communityParams,
        locationParams: locationParams,
        deviceTypeParams: deviceTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.locationModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // テーブル
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'profile1':
          return value.body
        case 'status':
          return Utility.getConstantsLabel(['Admp', 'LocationStatus'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchLocationId = null
      this.searchDeviceSerial = null
      this.searchNickName = null
      this.searchAttribute = ''
      this.searchDeviceType = ''
      this.searchStatus = ''
    },
    search () {
      this.loading = true

      // データ検索パラメータ
      let locationParams = {
        communityUuid: this.communityId,
        filters: {}
      }
      if (this.searchLocationId)
        locationParams.filters.locationId = this.searchLocationId
      if (this.searchDeviceSerial)
        locationParams.filters.deviceSerial = this.searchDeviceSerial
      if (this.searchNickName)
        locationParams.filters.nickName = this.searchNickName
      if (this.searchAttribute !== '')
        locationParams.filters.attributeGroupUuid = this.searchAttribute
      // if (this.searchAttribute !== '')
        // locationParams.filters.attributeUuid = this.searchAttribute
      if (this.searchDeviceType !== '')
        locationParams.filters.deviceTypeUuid = this.searchDeviceType
      if (this.searchStatus !== '')
        locationParams.filters.status = this.searchStatus

      // データ読出し
      this.loadLocationList({
        locationParams: locationParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.locationModel)
        })
        .catch(error => {
          this.loading = false
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'CommunityLocation',
        params: {
          communityId: String(this.communityId),
          locationId: String(props.row.locationUuid)
        }
      })
    },
  }
}